import React from "react";

/**
 * Multi-color hand-drawn squiggle divider — red / yellow / green.
 * Use between major sections for a playful, marker-art feel.
 */
export default function Squiggle({ className = "", ariaHidden = true }) {
  return (
    <div
      data-testid="squiggle-divider"
      aria-hidden={ariaHidden}
      className={`squiggle-divider mx-auto w-full max-w-6xl ${className}`}
    />
  );
}

/** A single hand-drawn dot — useful for decorative accents */
export function DoodleDot({ color = "tomato", size = 14, className = "" }) {
  const fill =
    color === "tomato"
      ? "#EE1111"
      : color === "sun"
      ? "#9B958D"
      : color === "green"
      ? "#3E3936"
      : color;
  return (
    <span
      aria-hidden="true"
      style={{ width: size, height: size, backgroundColor: fill }}
      className={`inline-block rounded-full ${className}`}
    />
  );
}
